const SITE_URL = 'https://documentiq.algoscale.com'
const ALGOSCALE_URL = 'https://algoscale.com'
const ALGOSCALE_LINKEDIN = 'https://www.linkedin.com/company/algoscale'

interface AuthorProfile {
  type: 'Person' | 'Organization'
  url?: string
  jobTitle?: string
  sameAs?: string[]
  image?: string
}

const AUTHOR_DIRECTORY: Record<string, AuthorProfile> = {
  'DocumentIQ Team': {
    type: 'Organization',
    url: SITE_URL,
    sameAs: [ALGOSCALE_URL, ALGOSCALE_LINKEDIN],
    image: `${SITE_URL}/algoscale-logo.png`,
  },
  'Algoscale': {
    type: 'Organization',
    url: ALGOSCALE_URL,
    sameAs: [ALGOSCALE_LINKEDIN],
    image: `${SITE_URL}/algoscale-logo.png`,
  },
}

export function buildAuthorSchema(authorName: string): Record<string, unknown> {
  const profile = AUTHOR_DIRECTORY[authorName]

  if (!profile) {
    return {
      '@type': 'Person',
      name: authorName,
      worksFor: {
        '@type': 'Organization',
        name: 'Algoscale',
        url: ALGOSCALE_URL,
      },
    }
  }

  const schema: Record<string, unknown> = {
    '@type': profile.type,
    name: authorName,
  }
  if (profile.url) schema.url = profile.url
  if (profile.jobTitle) schema.jobTitle = profile.jobTitle
  if (profile.image) schema.image = profile.image
  if (profile.sameAs && profile.sameAs.length > 0) schema.sameAs = profile.sameAs

  if (profile.type === 'Person') {
    schema.worksFor = {
      '@type': 'Organization',
      name: 'Algoscale',
      url: ALGOSCALE_URL,
    }
  }

  return schema
}

export function buildPublisherSchema(): Record<string, unknown> {
  return {
    '@type': 'Organization',
    name: 'DocumentIQ',
    url: SITE_URL,
    logo: {
      '@type': 'ImageObject',
      url: `${SITE_URL}/algoscale-logo.png`,
      width: 172,
      height: 49,
    },
    parentOrganization: {
      '@type': 'Organization',
      name: 'Algoscale',
      url: ALGOSCALE_URL,
    },
  }
}
